(() => {
  const start = () => {
    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches) return;
    const candidates = [...document.querySelectorAll('main .section-heading, main .uniform-product, main .feature-copy, main .feature-media, main .palletizer-home-media, main .palletizer-scene, main .industry-grid article, main .home-case-preview-grid > a, main .certificate-gallery article, main .capability-grid article, main .news-grid article, main .company-copy, main .company-images, main .palletizer-table tbody tr, main .cta-panel')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('hn-motion-visible');
      observer.unobserve(entry.target);
    }), {rootMargin:'0px 0px -24px 0px', threshold:0});
    candidates.forEach(el => {
      if (el.getBoundingClientRect().top < innerHeight || el.closest('form')) return;
      const siblings = [...el.parentElement.children];
      el.style.setProperty('--hn-delay', `${Math.min(siblings.indexOf(el) % 3, 2) * 70}ms`);
      el.classList.add('hn-motion-reveal');
      observer.observe(el);
    });
    const progress = document.createElement('div');
    progress.className = 'hn-scroll-progress';
    progress.setAttribute('aria-hidden','true');
    document.body.append(progress);
    let scheduled = false;
    const update = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.transform = `scaleX(${max > 0 ? Math.min(1,Math.max(0,scrollY/max)) : 0})`;
      scheduled = false;
    };
    const onScroll = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
    addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',onScroll,{passive:true});
    document.addEventListener('focusin',event => event.target.closest('.hn-motion-reveal')?.classList.add('hn-motion-visible'));
    preference.addEventListener('change',event => {
      if (!event.matches) return;
      observer.disconnect();
      candidates.forEach(el => el.classList.add('hn-motion-visible'));
      progress.remove();
      removeEventListener('scroll',onScroll);
      removeEventListener('resize',onScroll);
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
